import { Routes, Route,  useLocation} from 'react-router-dom';
import Home from "../../routes/Home";
import About from "../../routes/About";
import Contact from "../../routes/Contact";
import Board from "../Board/Board";
import NotFound from "../../routes/NotFound";
import Executives from '../Executives/Executives';
import NewsLetters from "../Research/Newsletters";
import Articles from "../Research/Articles";
import EquityResearch from '../Research/EquityResearch';
import MarketReview from '../Research/MarketReview';
import Gallery from '../Gallery/Gallery';
import GalleryPhotos from '../Gallery/GalleryPhotos';
import Calculator from '../InvestmentCalculator/InvestmentCalculator';
import Layout from '../Layout/Layout';
import Downloads from '../Downloads/Downloads';
import  FAQs  from '../FAQ/FAQs';
// import Services from '../Services/Services';
import Products from '../Products/Products';


const App = () => {
 
  const location = useLocation();
  const { pathname } = location;
  const group  = pathname.substring(14);

  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
          <Route path="board" element={<Board />} />
          <Route path="executives" element={<Executives />} />
          <Route path="newsletters" element={<NewsLetters />} />
          <Route path="articles" element={<Articles />} />
          <Route path="equity_research" element={<EquityResearch />} />
          <Route path="market_review" element={<MarketReview />} />
          <Route path="gallery" element={<Gallery />} />
          <Route path={`/photos_group/${group}`} element={<GalleryPhotos value={ group } />} />  
          <Route path="investment_calculator" element={<Calculator />} />
          <Route path="/form_downloads" element={<Downloads />} />
          <Route path="/faq" element={<FAQs />} />
          <Route path="/our_business" element={<Products />} />
          <Route path="*" element={<NotFound />} />          
        </Route>
      </Routes>
    </>
  );
};

export default App;

